/**
 * Keep secondary hits at the end of a combined result list so they cannot
 * outrank primary hits in mixed Quick Search.
 *
 * Empty primary lists fill leftover slots from secondary up to `totalLimit`.
 * Mixed lists cap secondary at `maxSecondary` and reserve those slots by
 * trimming primary.
 */
export function appendLowRankHits<T>(primary: T[], secondary: T[], totalLimit: number, maxSecondary: number): T[] {
  if (primary.length === 0) {
    return secondary.slice(0, Math.max(0, totalLimit));
  }

  const secondaryHits = secondary.slice(0, Math.max(0, maxSecondary));
  const primaryLimit = Math.max(0, totalLimit - secondaryHits.length);
  return [...primary.slice(0, primaryLimit), ...secondaryHits];
}
